export default __webpack_public_path__ + "static/media/15.5a0f2ffb.jpg";